<template>
  <article class="mobile-menu">
    <section class="menu-container" :class="[isShow ? 'mobile-active' : '']">
      <div class="menu">
        <div class="menu__content">
          <!-- sidemenu close btn -->
          <button class="close-btn" @click="toggleContent()">
            <img
              src="@/assets/images/layouts/header/mobileHeader/closebtn.svg"
              alt=""
            />
          </button>
          <!-- sidemenu -->
          <CommonLoginSideBarDefault
            @openContent="toggleContent()"
            :userInfo="userInfoData"
            :mainMenu="mainMenuData"
            :isShow="isShow"
          />
        </div>
      </div>
    </section>
    <!-- <div v-if="isShow" class="logout-btn open-btn">
            <button class="highlight highlight__500" @click="betaClickHandler">
                <img src="@/assets/images/layouts/sideBar/mainMenu/FAQ.svg" alt="">
                FAQ
            </button>
            <button class="highlight highlight__500" @click="logoutEvent">
                <img src="@/assets/images/layouts/sideBar/mainMenu/logout.svg" alt="">
                Log out
            </button>
        </div> -->
  </article>

  <!-- <ClientOnly>
        <ui-dialog-alert
            :width         = "43"
            :height        = "21"
            :title         = copyDialog.title
            :btnName       = copyDialog.btnName
            :isError       = "false"
            :isVisible     = copyDialog.visible
            :useOverLay    = "true"
            @onDialogClose = "closeCopyDialog"
        />
    </ClientOnly> -->
</template>

<script setup>
import CommonLoginSideBarDefault from "@/components/common/login/SideBarDefault.vue";
import { ref, defineProps, defineEmits, watch, computed } from "vue";
import { useStore } from "vuex";
// import {UserInfo}        from '~/client_api/login/after_login.js'
// import { logoutHandler } from '~/client_api/user/user_api';
const store = useStore();
const props = defineProps({
  isShow: Boolean,
  isLogin: Boolean,
  foldingMenu: Boolean,
});

const showContent = ref(false);
// const userStore       = useUserStore();
// const userData        = userStore.getUserInfo();
// const dialogVisible   = ref(false);
const mainMenuData = computed(
  () => store.getters["useMainMenuList/mainMenuItems"]
);

// const popupStore      = usePopupList();

// const userInfoData    = new UserInfo(
//     {
//         nickName  : userData.nickName,
//         email     : userData.email,
//         imageUrl  : userData.imageUrl,
//         subscribe : userData.subscribe,
//         referrals : userData.referrals,
//         wallet    : userData.wallet,
//         kibotAuto : userData.kibotAuto,
//         grade     : userData.grade,
//         gradeIcon : userData.gradeIcon
//     }
// );

// let copyDialog = ref({
//   title: "Referral code has been copied",
//   msg: "<div>asdsd</div>",
//   btnName: "Close",
//   visible: false,
// });

// const selectReferrals = () => {
//     const userData = useUserStore().userData;
//     const origin   = `${window.location.origin}`;
//     dialogVisible.value = false;
//     copyDialog.value.visible = true;
//     emit("openDialog", dialogVisible.value);
//     navigator.clipboard.writeText(`${origin}/signup?referral=${userData.user_ref_id}`);
// }

// const closeCopyDialog = () => {
//     copyDialog.value.visible = !copyDialog.value.visible;
// }

const emit = defineEmits(["openContent"]);
const toggleContent = () => {
  showContent.value = !showContent.value;
  // dialogVisible.value = false;

  emit("openContent", showContent.value);
};

// const betaClickHandler = (showPopup) => {
//     popupStore.openBetaPopup(true);
// }

// const logoutEvent = () => {
//     logoutHandler();
//     showContent.value = false;
//     emit("openContent", showContent.value);
// }

watch(
  () => props.isShow,
  (newVal) => {
    if (newVal) {
      mainMenuData.value.forEach((ob) => {
        if (ob.subMenu && ob.hasSubmenu) {
          if (ob.isActive) {
            ob.subMenuToggle = true;
            ob.depth = 2;
          } else {
            ob.subMenuToggle = false;
            ob.depth = 1;
          }
        }
      });
    } else {
      // copyDialog.value.visible = false;
      showContent.value = false;
      // popupStore.openBetaPopup(false);
      mainMenuData.value.forEach((ob) => {
        if (ob.subMenu && ob.hasSubmenu) {
          ob.subMenuToggle = false;
          ob.depth = 1;
        }
      });
    }
  }
);
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/common/login/after/MobileMenu.scss";
</style>
